export const Modal = {
  baseStyle: {
    dialog: {
      bg: "#FDFDFD",
      maxWidth: ["300px", "450px"],
      minWidth: ["300px", "450px"],
      width: "auto",
      boxShadow: '0 3px 6px rgba(0, 0, 0, 0.15)',
      borderRadius: '14px',
    },
    header: {
      paddingTop: 6,
      fontSize: '1.3em',
    },
    footer: {
      paddingBottom: 6,
    },
    overlay: {
      bgColor: 'rgba(0, 0, 0, 0.15)',
    },
  },
  sizes: {
    lg: {
      dialog: {
        width: ['90%', '600px'],
        minWidth: ['90%', '600px'],
      }
    },
    md: {
      dialog: {
        width: ['90%', '500px'],
        minWidth: ['90%', '500px'],
      },
    },
    sm: {
      dialog: {
        width: ['90%', '425px'],
        minWidth: ['90%', '425px'],
      }
    }
  }
};
